import { useState } from "react";
import { Button, ModalDelete } from "expano-components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";
import { Main, PageLoader, Error } from "components";

import { ReactComponent as PlatformIcon } from "icons/channel.svg";

import BasicData from "./components/BasicData";
import AllegroAds from "./components/AllegroAds";
import CpcSalesPeriods from "./components/CpcSalesPeriods";
import ChannelCampaign from "./components/ChannelCampaign";

const ChannelEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: channel,
    refetch,
  } = useGet({
    query: ["channels", id],
    path: `/channels/${id}`,
    context: "ui_show",
  });

  const { _delete: deleteChannel } = useDelete({
    path: `/channels/${id}`,
    onSuccess: () => {
      setShowDeleteModal(false);
      history.push("/channels");
    },
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: channel?.identifier,
        icon: <PlatformIcon />,
        breadcrumbs: [
          {
            name: "Kanały",
            path: "/channels",
          },
          { name: channel?.identifier },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń kanał"
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={deleteChannel}
          handleClose={() => setShowDeleteModal(null)}
          name={`kanał ${channel.identifier}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            {...channel}
            refetch={refetch}
            initialValues={{
              ignore_bundle_products: channel?.ignore_bundle_products,
              ignore_virtual_products: channel?.ignore_virtual_products,
              additional_channel_shipping_price:
                channel?.additional_channel_shipping_price ?? 0,
              free_channel_shipping_rate_id:
                channel?.free_channel_shipping_rate_id ?? null,
            }}
          />
        </div>
        <div className="column-half">
          <AllegroAds {...channel} refetch={refetch} />
          <ChannelCampaign
            channel_id={channel?.id}
            initialValues={{
              min_roas: channel?.min_roas || 0,
              max_roas: channel?.max_roas || 0,
              min_average_use_daily_budget:
                channel?.min_average_use_daily_budget || 0,
              max_average_use_daily_budget:
                channel?.max_average_use_daily_budget || 0,
            }}
          />
          <CpcSalesPeriods
            channel_id={channel?.id}
            data={channel?.channel_sales_periods}
            refetch={refetch}
          />
        </div>
      </div>
    </Main>
  );
};

export default ChannelEdit;
